<template>
<div class="MCategoryList">
    <MHeader></MHeader>
    <div class="m-body">
        <div class="box" v-for="(obj) in dataList" :key="obj.parentcode">
            <div class="left" @click="gotoSeacher(obj)">
                <div class="icon" :class="'icon-sort'+obj.parentcode"></div>
                <div class="name">{{obj.codename}}</div>
            </div>
            <div class="right">
                <div class="outbox">
                    <div class="secName"  v-for="(obj2) in obj.codelist" :key="obj2.code" @click="gotoSeacher2(obj2)">{{obj2.name}}</div>

                </div>
            </div>
        </div>
    </div>
    <!--<MTab></MTab>-->
</div>
</template>

<script>
// import MTab from 'views/mobile/components/tab/mTab'
import MHeader from 'views/mobile/components/mheader/mHeader'
import {getStudyInterestList} from 'api/course'
import {mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MCategoryList',
    data() {
        return {
            dataList: []
        }
    },
    mounted() {
        this.getList()
    },
    activated() {
        $("html,body").animate({scrollTop:"0px"},0)
    },
    methods: {
        gotoSeacher(obj) {
            this.$router.push({name: 'MSearchList', query: {catecode: obj.parentcode, key: ''}})
            this.setRefresh(true)
        },
        gotoSeacher2(obj2) {
            this.$router.push({name: 'MSearchList', query: {catecode: obj2.code, key: ''}})
            this.setRefresh(true)
        },
        getList() {
            this.setLoading(true)
            getStudyInterestList({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.dataList = data.data.content
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        MHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.MCategoryList {
    position: relative;
    padding: 0.88rem 0;
    background: $c-white;
    .m-body{
        padding: 0 0.32rem;
        .box{
            display: flex;
            align-items: flex-start;
            .left{
                padding-left:0.16rem;
                padding-right: 0.2rem;
                width: 1.2rem;
                min-width: 1.2rem;
                max-width: 1.2rem;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                flex-direction: column;
                margin: 0.4rem 0;
                .icon{
                    width: 0.6rem;
                    height: 0.6rem;
                }
                .name{
                    font-size: 0.24rem;
                    font-weight: 600;
                    line-height: 0.32rem;
                    color: $c-blue;
                }
            }
            .right{
                overflow: hidden;
                .outbox{
                    position: relative;
                    margin-left: -0.01rem;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    flex-wrap: wrap;
                    color: $c-black;
                    font-size: 0.26rem;
                    line-height: 0.36rem;
                    padding: 0.4rem 0 0.02rem 0;
                    .secName{
                        margin-left: -0.01rem;
                        padding: 0 0.32rem;
                        margin-bottom: 0.28rem;
                        border-left: 0.01rem solid $line;
                    }
                }
            }
        }
        .box+.box{
            border-top: 0.01rem solid $line;
        }
    }
}
</style>